import { Fragment, useState, memo } from 'react';
import { useDispatch } from 'react-redux';
import { deleteClient } from 'redux/slices/client';
import ModalWithChildren from 'components/ModalWithChildren';
import { clientDetailsActions as TEXT } from 'locales/en/client';

const DeleteClient = ({ client, className, onClick }) => {
  const [showModel, setShowModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const dispach = useDispatch();

  const handleDeleteCta = () => {
    setIsDeleting(true);
    dispach(deleteClient(client.id)).then((action) => {
      if (action.type.endsWith('fulfilled')) {
        setShowModal(false);
        setIsDeleting(false);
      }

      if (action.type.endsWith('rejected')) {
        setIsDeleting(false);
      }
    });
  };
  return (
    <Fragment>
      <button
        type="button"
        className={className}
        onClick={() => setShowModal(true)}
      >
        Delete
      </button>
      <ModalWithChildren
        ctaType="button"
        isLoading={isDeleting}
        isOpen={showModel}
        header={TEXT.deleteClientModalHeader(
          client.companies?.meta?.pagination?.total
        )}
        ctaTitle={TEXT.deleteClientModalCtaTitle}
        cta2Title={TEXT.deleteClientModalCta2Title}
        onClickCta2={() => setShowModal(false)}
        onClickCta={() => handleDeleteCta()}
      />
    </Fragment>
  );
};

export default memo(DeleteClient);
